import type { FC } from 'react';

import RegistryModuleForm from './RegistryModuleForm';
import type { RegistryModuleSelection } from './RegistryModuleForm.types';
import { useCreateVersionMutation } from './ProjectVersions.queries';

interface ForkVersionFormProps {
    projectIdn?: string;
    onClose: () => void;
}

const ForkVersionForm: FC<ForkVersionFormProps> = ({ projectIdn, onClose }) => {
    const createVersionMutation = useCreateVersionMutation();

    const handleFork = async (
        selection: RegistryModuleSelection
    ): Promise<void> => {
        if (!projectIdn || !selection.projectVersionId) {
            return;
        }
        try {
            await createVersionMutation.mutateAsync({
                projectIdn,
                sourceProjectVersionId: selection.projectVersionId
            });
            onClose();
        } catch {
            return;
        }
    };

    return (
        <RegistryModuleForm
            isPending={createVersionMutation.isPending}
            isSubmitDisabled={!projectIdn}
            submitLabel="Fork"
            onCancel={onClose}
            onSubmit={handleFork}
        />
    );
};

export default ForkVersionForm;
